var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-form-item",
    {
      staticClass: "ik-image",
      attrs: { label: _vm.name, required: _vm.getRequire },
    },
    [
      _c(
        "el-upload",
        {
          ref: "upload",
          staticClass: "upload_button",
          attrs: {
            disabled: _vm.disabled,
            action: "",
            data: { token: _vm.token },
            accept: _vm.accept,
            "file-list": _vm.fileList,
            "show-file-list": false,
            "http-request": _vm.uploadImage,
            limit: _vm.maxSize === 0 ? 10000 : _vm.maxSize,
          },
        },
        [
          _c(
            "el-tooltip",
            {
              staticClass: "item",
              attrs: {
                disabled:
                  _vm.tips === "" ||
                  _vm.tips === null ||
                  _vm.tips === undefined,
                effect: "dark",
                content: _vm.tips,
                placement: "top",
              },
            },
            [
              _c("el-input", {
                staticClass: "input",
                class: { require: _vm.getRequire && _vm.isNull() },
                attrs: {
                  type: "text",
                  size: "small",
                  clearable: true,
                  disabled: _vm.disabled,
                },
                on: { input: _vm.click },
                model: {
                  value: _vm.val,
                  callback: function ($$v) {
                    _vm.val = $$v
                  },
                  expression: "val",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      !_vm.isNull()
        ? _c("i", {
            staticClass: "el-icon-view",
            staticStyle: { cursor: "pointer", "font-size": "16px" },
            on: { click: _vm.showImg },
          })
        : _vm._e(),
      !_vm.isNull()
        ? _c("el-image", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: false,
                expression: "false",
              },
            ],
            ref: "image",
            staticClass: "img",
            staticStyle: { width: "40px", height: "40px" },
            attrs: { src: _vm.imageUrl, "preview-src-list": _vm.previewList },
            on: { click: _vm.showImg },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }